import "./App.css";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PrivateRoutes from "./routing/PrivateRoutes";
import Alert from "./components/Alert/Alert";
import AuthRoutes from "./routing/AuthRoutes";
import { sync_data_thunk } from "./redux/auth/authThunk";
import { USER_AU_TOKEN } from "./common/key";
// import Alert from './components/Loader/Alert';
function App() {
  // Get total space used (in bytes)

  let tokenState = localStorage.getItem(USER_AU_TOKEN);
  let bool = false;
  if (tokenState) {
    bool = true;
  }
  const [currentUser, setCurrentUser] = useState(bool);

  const auth = useSelector((state) => state.auth?.isLogin);
  const dispatch = useDispatch();
  useEffect(() => {
    if (typeof localStorage !== "undefined") {
      const token = localStorage.getItem(USER_AU_TOKEN);
      const isLoggedIn = token;
      setCurrentUser(isLoggedIn);
    }
  }, [dispatch, auth]);
  return (
    <>
      <Alert />
      <Router>
        {/* only for react to logout  */}
        {/* <RedirectHash /> */}
        <Routes>
          {!currentUser ? (
            <>
              <Route path="/*" element={<AuthRoutes />} />
              <Route path="*" element={<Navigate to="/" />} />
            </>
          ) : (
            <>
              <Route path="/*" element={<PrivateRoutes />} />
              <Route path="*" element={<Navigate to="/" />} />
            </>
          )}
          {/* <Route path="settings" element={<Setting />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-of-service" element={<TermsAndConditions />} />
          <Route path="contact-us" element={<ContactUs />} /> */}
        </Routes>
      </Router>
    </>
  );
}

export default App;
